class CharChangeTempl {
	static getTempl(_d = {}) {
		return _d.map((_item, _idx) => {
			return `
            <li>
                <span>${_item.serverName}</span>
                <ul class="bns-character-list">${_item.characterList.map( CharChangeTempl.item ).join('')}</ul>
            </li>`;
		}).join('');
	}

	static item(_d = {}) {
		let mastery = (_d.masteryFactionName)? `, ${_d.masteryFactionName} ${_d.masteryLevel}성`: '';
		
		return `
        <li data-name="${_d.name}" data-serverid="${_d.serverId}" data-servertype="${_d.serverType}">
            <span>${_d.name} | Lv.${_d.level}${mastery} | ${_d.jobName}</span>
        </li>`;
	}

} // end of class


export default CharChangeTempl;
